
import { defineComponent } from 'vue'

export default defineComponent({
    name: "NameHeading",

    props:[
        "pageScrollVal",
        "isMounted"
    ],

    data(){
        return{
            transDur: [1400, 3050], // The svg path transition duration in ms
            svgElems: [] as HTMLElement[]
        } 
    },

    mounted(){

        this.$nextTick(() => {
            this.svgElems = Array.from(document.querySelectorAll(".head-svg"));

            this.getPathLength();
            
            window.addEventListener("scroll", this.parallaxPaths);
        });

    },

    methods:{

        getPathLength(){

            this.svgElems.forEach((svgElem, svgIndex) => {
                const svgPaths = svgElem.querySelectorAll("path");

                for (let i = 0; i < svgPaths.length; i++){

                    const path = svgPaths[i];
                    const pathLength = path.getTotalLength();
                    const pathDelay = (i * 0.11).toString() + "s";

                    // Set initial state (no visible length)
                    path.style.strokeDasharray = `${pathLength}px`;
                    path.style.strokeDashoffset = `${pathLength}px`;

                    // Animate the path to be fully visible
                    setTimeout(() => {
                        path.style.transition = `${this.transDur[svgIndex] / 1000}s cubic-bezier(.1,.5,.4,1)`;
                        path.style.transitionDelay = pathDelay;
                        path.style.strokeDashoffset = "0px";

                        setTimeout(() => {
                            path.style.transition = "0.15s cubic-bezier(.1,.5,.4,1)";
                            path.style.transitionDelay = "0s";
                        }, this.transDur[svgIndex]);

                    }, 0);

                }
            });

        },

        parallaxPaths(){

            this.svgElems.forEach((svgElem) => {
                const svgPaths = svgElem.querySelectorAll("path");

                for (let i = 0; i < svgPaths.length; i++){

                    const windowHeight = window.innerHeight;
                    const path = svgPaths[i];

                    // + 5 removes a gap (it's a visual bug)
                    const pathLength = path.getTotalLength() + 5; 

                    // Get the page scroll percentage 
                    // x * 1.7 makes the unloading faster relative to the scroll position
                    let scrollPercent = 
                        100 - (this.pageScrollVal / windowHeight * 100 * 1.7);

                    // Ensure the scroll percentage stays between 0-100
                    scrollPercent = Math.max(0, Math.min(100, scrollPercent));

                    const pathVisLength = pathLength * (scrollPercent / 100);

                    // Keep strokeDasharray consistent, change strokeDashoffset to control visibility
                    path.style.strokeDasharray = `${pathLength}px`;
                    path.style.strokeDashoffset = `${pathLength - pathVisLength}px`;
                }
            });

        }

    }

});
